/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import staticURL from 'lib/staticURL';
import TFIConstants, {AccountType} from 'notebook/tfi/TFIConstants';
import TFIUtil from 'notebook/tfi/TFIUtil';

interface Props {
  accountType: AccountType;
}

class TFIIcon extends React.Component<Props> {
  override render(): JSX.Element {
    return (
      <img
        alt={`${TFIUtil.readableAccountType(this.props.accountType)} logo`}
        className="tfi-addAccountRow-icon u-spacing-right"
        src={(() => {
          switch (this.props.accountType) {
            case TFIConstants.ACCOUNT_TYPE.BOX:
              return staticURL('/static/img/tfi/box.png');
            case TFIConstants.ACCOUNT_TYPE.DROPBOX:
              return staticURL('/static/img/tfi/dropbox.png');
            case TFIConstants.ACCOUNT_TYPE.EGNYTE:
              return staticURL('/static/img/tfi/egnyte.png');
            case TFIConstants.ACCOUNT_TYPE.GDRIVE:
              return staticURL('/static/img/tfi/gdrive.png');
            case TFIConstants.ACCOUNT_TYPE.ONEDRIVE:
              return staticURL('/static/img/tfi/onedrive.png');
            default:
              return undefined;
          }
        })()}
      />
    );
  }
}

export default TFIIcon;
